module.exports = __webpack_public_path__ + "img/saml.300e14cf.png";